import { environmentConfig } from "@src/appV2/environment";
import { CreateWorkerSSNViewPayload } from "../hooks/workerDrawer/useCreateWorkerSsnView";
import { getAuthHeader } from "src/utils/superagent";
import request from "superagent";

const workerServiceUrl = environmentConfig.REACT_APP_WORKER_SERVICE_URL;

export const POST_SSN_WORKER_ENDPOINTS = "/workers/:workerId/ssn-views";

export interface WorkerSSNResponse {
  ssn: string;
}

export const createWorkerSSNView = async ({
  workerId,
  isWorkerAllowedToViewFullSSN = false,
}: CreateWorkerSSNViewPayload): Promise<WorkerSSNResponse> => {
  const response = await request
    .post(`${workerServiceUrl}${POST_SSN_WORKER_ENDPOINTS.replace(":workerId", workerId)}`)
    .set(await getAuthHeader())
    .catch((error) => {
      const errorResponse = error?.response?.body;
      if (
        errorResponse?.statusCode === 404 &&
        errorResponse.error === "Not Found" &&
        isWorkerAllowedToViewFullSSN
      ) {
        return;
      }

      // Check if the error is a 404 "Not Found" and if the worker is allowed to view full SSN
      throw error;
    });
  const responseAttributes = response?.body?.data?.attributes;
  return { ssn: responseAttributes?.ssn || "" };
};
